import React from 'react';
import PropTypes from 'prop-types';
import {AvailStringField} from '../../../value-comparing/helper-components';

const ErrorResult = ({error}) => (
  <>
    {Object.keys(error).map(availKey => (
      <AvailStringField assignedKey={availKey} key={availKey} value={error[availKey]} />
    ))}
  </>
);

ErrorResult.propTypes = {
  error: PropTypes.object,
};

export default ErrorResult;
